import { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";

const RoutePageLoader = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  // useLayoutEffect fires synchronously before paint, so the skeleton overlay
  // appears immediately on navigation instead of after the first frame.
  useLayoutEffect(() => {
    setLoading(true);
    const timer = window.setTimeout(() => setLoading(false), 500);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search]);

  if (!loading) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[95] bg-background/90 backdrop-blur-[1px]">
      <div className="container py-8 space-y-6">
        <Skeleton className="h-8 w-72" />
        <Skeleton className="h-4 w-[32rem] max-w-full" />
        <div className="grid gap-3 md:grid-cols-4">
          <Skeleton className="h-11 w-full rounded-lg" />
          <Skeleton className="h-11 w-full rounded-lg" />
          <Skeleton className="h-11 w-full rounded-lg" />
          <Skeleton className="h-11 w-full rounded-lg" />
        </div>
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="rounded-lg border border-border bg-card p-3">
              <Skeleton className="aspect-[4/3] w-full rounded-lg" />
              <div className="mt-3 space-y-2">
                <Skeleton className="h-4 w-4/5" />
                <Skeleton className="h-3 w-2/3" />
                <Skeleton className="h-4 w-1/2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoutePageLoader;
